var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcNext = function SvgIcNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7 12",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.708 6.718a.75.75 0 0 0 .22-.53v-.38a.77.77 0 0 0-.22-.53L1.568.148a.5.5 0 0 0-.71 0l-.71.71a.49.49 0 0 0 0 .7l4.45 4.44-4.45 4.44a.5.5 0 0 0 0 .71l.71.7a.5.5 0 0 0 .71 0l5.14-5.13Z"
  })));
};
export default SvgIcNext;